import * as i0 from '@angular/core';
import { inject, APP_ID, Service } from '@angular/core';
const counters = new Map();
class _IdGenerator {
  _appId = inject(APP_ID);
  static _infix = `a${Math.floor(Math.random() * 100000).toString()}`;
  getId(prefix, randomize = false) {
    if (this._appId !== 'ng') {
      prefix += this._appId;
    }
    let count = counters.get(prefix);
    if (count === undefined) {
      count = 0;
    } else {
      count++;
    }
    counters.set(prefix, count);
    return `${prefix}${randomize ? _IdGenerator._infix + '-' : ''}${count}`;
  }
  static ɵfac = function _IdGenerator_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || _IdGenerator)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineService({
    token: _IdGenerator,
    factory: _IdGenerator.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(_IdGenerator, [{
    type: Service
  }], null, null);
})();
export { _IdGenerator };
